<template>
    <span v-if="isAdmin">
        <v-btn outlined class="text-none text-no-wrap mr-2" @click="open">
            <v-icon left small>mdi-account-tie-outline</v-icon>
            Managers
        </v-btn>

        <v-dialog v-model="dialog" max-width="560">
            <v-card>
                <v-card-title class="text-h6">Time Tracking Managers</v-card-title>
                <v-card-text>
                    <p class="text-body-2 grey--text text--darken-1 mb-4">
                        Managers can see time tracking for <strong>all users</strong> on this page and receive the
                        daily utilization and unusual activity report emails.
                    </p>
                    <v-autocomplete
                        v-model="selectedIds"
                        :items="userItems"
                        :loading="loading"
                        :disabled="loading"
                        label="Managers"
                        multiple
                        chips
                        small-chips
                        deletable-chips
                        outlined
                        dense
                        hide-selected
                        prepend-inner-icon="mdi-account-multiple-outline" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialog = false">Cancel</v-btn>
                    <v-btn color="primary" text :loading="saving" :disabled="loading" @click="save">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
// Who may edit the list. TimeTrackingManagerController::canManage in
// dgtasks_api is the real check; keep the two in step.
const ADMIN_ROLE_ID = 1;
const TIME_TRACKING_ADMIN_USER_IDS = [47];

export default {
    name: 'TimeTrackingManagersButton',

    inject: ['users'],

    data() {
        return {
            dialog: false,
            loading: false,
            saving: false,
            selectedIds: [],
        };
    },

    computed: {
        isAdmin() {
            const user = this.$store.getters['auth/get_user'];
            if (!user) return false;
            return user.role_id === ADMIN_ROLE_ID
                || TIME_TRACKING_ADMIN_USER_IDS.includes(user.id)
                || (user.role_members || []).some(m => m.user_role_id === ADMIN_ROLE_ID);
        },
        userItems() {
            return [...(this.users() || [])]
                .filter(u => u && u.id && u.name)
                .sort((a, b) => a.name.localeCompare(b.name))
                .map(u => ({ text: u.email ? `${u.name} (${u.email})` : u.name, value: u.id }));
        },
    },

    methods: {
        async open() {
            this.dialog = true;
            this.loading = true;
            try {
                const res = await this.$axios.get('api/agent/managers');
                if (res.data?.response) {
                    this.selectedIds = res.data.managers.map(m => m.user_id);
                } else {
                    this.$toast.error(res.data?.message || 'Failed to load managers');
                }
            } finally {
                this.loading = false;
            }
        },
        async save() {
            this.saving = true;
            try {
                const res = await this.$axios.post('api/agent/managers', { user_ids: this.selectedIds });
                if (res.data?.response) {
                    this.$toast.success('Managers updated');
                    this.dialog = false;
                } else {
                    this.$toast.error(res.data?.message || 'Failed to save managers');
                }
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>
